import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import classnames from 'classnames';
import { MapToolIcon } from '../../Icons/icons';
import { olMap } from '../../map/map';
import { Control } from '../../map/types';
import './toolbar.scss';

type Props = {
    children: React.ReactElement[];
};

const useStyle = makeStyles()((theme: Theme) =>
    {
        return {
            tool: {
                backgroundColor: theme.palette.common.white,
                fill: theme.palette.primary.dark,

                ['&:hover']: {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.common.white,
                    fill: theme.palette.common.white,
                },
            }
        }
    });

export function MapToolbar(props: Props): React.ReactElement {
    return <div className="toolbar">{props.children}</div>;
}

type MapToolProps = {
    label: string;
    control: Control;
    src: string;
    onActivate?: () => void;
    ariaLabel?: string;
};

export function MapTool(props: MapToolProps): React.ReactElement {
    const { classes } = useStyle();
    const toolClass = classnames(classes.tool, 'tool');
    const clickHandler = (e): void => {
        e.preventDefault();
        props.control.activate(olMap);

        if (props.onActivate) {
            props.onActivate();
        }
    };

    return (
        <button className={toolClass} onClick={clickHandler} aria-label={props.ariaLabel}>
            <span className="maptool-text">{props.label}</span>
            <span className="maptool-icon-wrapper">
                <MapToolIcon type={props.src} />
            </span>
        </button>
    );
}
